<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <template v-if="! solicitar_pin">
                        <div class="form-group">
                            <label for="n_abonado">{{ $t('formularios.n_abonado_anterior') }}</label>
                            <ValidationProvider name="número de abonado" rules="required" v-slot="{ errors }">
                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.n_abonado_anterior')" v-model="n_abonado">
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="dni">DNI</label>
                            <ValidationProvider name="dni" rules="required" v-slot="{ errors }">
                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="DNI" v-model="dni">
                            </ValidationProvider>
                        </div>
                    </template>
                    <template v-else>
                        <div class="form-group">
                            <label for="id">ID</label>
                            <ValidationProvider name="ID" rules="required" v-slot="{ errors }">
                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="ID" v-model="persona_id">
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="pin">PIN (Ultimas 4 cifras del DNI)</label>
                            <ValidationProvider name="pin" rules="required" v-slot="{ errors }">
                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="PIN" v-model="pin">
                            </ValidationProvider>
                        </div>
                    </template>  
                    
                    <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
                </ValidationObserver>
            </div>
            <div class="col-12" v-if="error">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-danger" role="alert">
                                    <p>{{ error }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {        
        data() {
            return {
                n_abonado: '',
                dni: '',
                loading: false,
                error: false,
                persona_id: '',
                pin: ''
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            solicitar_pin() {
                return this.$store.getters.getFooter.lfp_pin ? false : true;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.buscarAbonado();
                }
            },
            terminar() {
                this.$emit('terminado', {
                    n_abonado: this.b_abonado,
                    pin: this.pin
                });
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    tid: this.configuracion.hash_teatro,
                    n_abonado: this.n_abonado,
                    dni: this.dni,
                    pin: this.pin,
                    persona_id: this.persona_id
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.buscar.abono'), params).then(res => {
                    this.loading = false;
                    this.$emit('terminado', res.data);
                }).catch(error => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'akr1V2vNbDdxA3CkLniS') {
                        this.error = 'Nº de ID o PIN incorrecto. Por favor escriba a abonados@albacetebalompie.com con su Nombre, apellidos y DNI';
                    }
                });
            },
        },
        components: {
            ContentOrLoading
        }
    }
</script>

<style>

</style>
